var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssistedPay = function SvgAssistedPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".assisted-pay_svg__hand{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14 0 0 14 140 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "assisted-pay_svg__Shape",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    fill: "#1E88E5",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "assisted-pay_svg__Bar",
    fill: "#FFF",
    d: "M2 4h12v3H2z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.6 314.5c-22.3 0-44.6.1-67 0-10.7 0-16.7 2.4-16.4 15.8.4 21.5-16.6 33-32.8 41.7-15.3 8.2-28.3-.1-39.8-12.1-22.6-23.6-45.9-46.5-69.4-69.3-11.7-11.3-20.4-24.4-12.3-39.9 8.6-16.5 20.6-32.4 41.8-33.1 9.7-.3 16.1-3.4 23.3-9.1 33.3-25.8 70.1-37.5 112.2-24.7 8.4 2.6 17 4.7 25.7 5.9 27.7 3.9 53.6 2.4 71.1-24.4 3.9-5.9 10.1-10.4 15.2-15.5 16.6-16.3 26.1-17.7 44.6-4 5.2 3.9 8.4 1.8 12.5.5 13.3-4.3 25.2-1.4 33.7 9.2 4.9 6.1 9.3 6 16 5.1 15.4-1.9 27.8 4.2 34.8 18.1 7.2 14.4 5.6 28.6-5.9 40.2-26.2 26.7-52.5 53.1-79.2 79.3-11.7 11.4-26.6 15.8-42.7 15.9-21.8.5-43.6.3-65.4.4",
    style: {
      fill: "#333"
    },
    transform: "translate(0 120)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 418.8h-60.7c-3.6 0-8.1-1.2-10.7.5-19.1 11.7-28.8-2.4-39.9-13.6-16.7-17-33.6-33.9-50.6-50.6-4-3.9-7.6-7.1-1.2-12.1 24.4-19.2 51.8-35.1 82.8-27 45.1 11.8 90.4 9.9 135.8 10.3 23 .2 32.7 5.9 32.5 19.5-.1 13.4-9.6 18.8-33.1 18.8-16.6 0-33.2-.1-49.8.1-6.1 0-14-1-13.8 8.1.2 7.6 7.2 7.5 13 7.5 21.3 0 42.5.1 63.8 0 16.2-.1 27.2-8.2 34-22.8 11.7-25.3 34.6-40.4 54-58.6 6.6-6.2 15.9-3.2 22.3 3.7 7 7.5 7.3 16.2 1.1 24-5.8 7.2-12.8 13.5-19.4 20.1-18.3 18.4-36.8 36.5-54.9 55.1-11.6 11.9-25.2 17.5-41.7 17.2-21-.4-42.3-.2-63.5-.2",
    className: "assisted-pay_svg__hand"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.4 291c.2 4.2-3 6.3-5.5 8.8-7.6 7.7-15.5 15.2-22.8 23.3-5.1 5.6-7.3 3.7-13-.4-12.3-8.9-9.4-14.9.4-22.6 6.1-4.8 10.7-11.4 16.8-16.1 8.7-6.7 23.3-2 24.1 7M313.1 308.1c11.3-11.1 21.7-21.5 32.3-31.7 5.3-5.1 11.1-5.2 16.4 0 6.6 6.4 0 9.9-3.6 13.7-11.6 12-21.9 27.2-45.1 18",
    className: "assisted-pay_svg__hand"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 329.2c-2 13.6-12.7 20.9-22.5 27.8-7.8 5.5-15.4.4-21.8-6-24.4-24.7-49.1-49-73.5-73.7-12.6-12.7-11.8-18.4 3.4-33.5 14.3-14.1 20-14.8 32.2-2.6q36.9 36.6 73.5 73.5c4.1 4 8.8 7.8 8.7 14.5",
    style: {
      fill: "#6be"
    },
    transform: "translate(0 120)"
  }));
};
export default SvgAssistedPay;